import { TextField as TextFieldMUI, styled } from '@mui/material';
import React, { useState } from 'react';
import { themeOptions } from 'assets/styles/theme';
import { AUTO_GROW_MAX_ROWS } from 'components/Forms/TextField/TextField';

interface TextFieldSubfieldProps {
  pattern?: RegExp;
  inputComponent?: any;
  errorText?: string;
  shrink?: boolean;
  helperText?: string;
  maxLength?: number;
  label?: string;
  setValue: (value: string) => void;
  type?: string;
  defaultValue: string;
  isExtraAnnotation?: boolean;
  autoGrow?: boolean;
  variant?: string;
}

const StyledTextField = styled(TextFieldMUI)`
  width: 100%;
  margin-top: 8px;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
  input {
    &:invalid {
      color: ${themeOptions.palette.error.main}
    }
  }
`;

export default function TextFieldSubfields(
  {
    pattern,
    inputComponent,
    shrink,
    errorText = '',
    helperText,
    maxLength,
    label = '',
    setValue,
    type = 'text',
    defaultValue,
    isExtraAnnotation,
    autoGrow,
    variant = 'outlined',
  }: TextFieldSubfieldProps,
) {
  const [errorMessage, setErrorMessage] = useState('');
  const baseRows = isExtraAnnotation ? 6 : 1;
  const rowProps = autoGrow
    ? { minRows: baseRows, maxRows: Math.max(baseRows, AUTO_GROW_MAX_ROWS) }
    : { rows: baseRows };
  const handleChangeValue = (value : string) => {
    if (value === ' ' || value === '') {
      setValue('');
    } else if (!pattern || value.match(pattern)) {
      setValue(value);
      setErrorMessage('');
    } else {
      setErrorMessage(errorText);
    }
  };

  return (
    <StyledTextField
      type={type}
      helperText={helperText}
      error={errorMessage.length !== 0}
      errorText={errorMessage}
      id='outlined-basic'
      label={label}
      variant={variant}
      value={defaultValue}
      multiline
      {...rowProps}
      onChange={(e: React.FormEvent<HTMLInputElement>) => handleChangeValue(e.currentTarget.value)}
      InputProps={{
        pattern,
        shrink,
        maxLength,
        inputComponent,
      }}
    />
  );
}
